// src/lib/gameService.ts

// Re-exporta outras funções modulares (caso existam)
export * from './game';

import type { Game } from '../types/index';
import type { UserGame } from '../types';
import { supabase } from './supabase';

// Obter toda a coleção do usuário (owned, wishlist, played, etc.)
export async function getUserCollection(userId: string): Promise<UserGame[]> {
  if (!userId) return [];
  const { data, error } = await supabase
    .from('user_games')
    .select('*')
    .eq('user_id', userId);
  if (error) {
    console.error('getUserCollection error:', error);
    return [];
  }
  return (data || []).map((ug: any) => ({
    ...ug,
    play_count: ug.play_count ?? 0,
  }));
}

// Alternar status de posse
export async function toggleOwned(
  userId: string,
  gameId: string,
  isOwned: boolean
): Promise<UserGame> {
  const { data } = await supabase
    .from('user_games')
    .upsert(
      { user_id: userId, game_id: gameId, owned: isOwned },
      { onConflict: 'user_id,game_id' }
    )
    .select('*')
    .single();
  return { ...data!, play_count: data!.play_count ?? 0 };
}

// Alternar status de wishlist
export async function toggleWishlist(
  userId: string,
  gameId: string,
  isWishlist: boolean
): Promise<UserGame> {
  const { data } = await supabase
    .from('user_games')
    .upsert(
      { user_id: userId, game_id: gameId, wishlist: isWishlist },
      { onConflict: 'user_id,game_id' }
    )
    .select('*')
    .single();
  return { ...data!, play_count: data!.play_count ?? 0 };
}

// Alternar status de jogado (incrementa/decrementa play_count)
export async function togglePlayed(
  userId: string,
  gameId: string,
  isPlayed: boolean
): Promise<UserGame> {
  // busca existente
  const { data: existing } = await supabase
    .from('user_games')
    .select('*')
    .eq('user_id', userId)
    .eq('game_id', gameId)
    .maybeSingle();

  const newCount = isPlayed
    ? ((existing?.play_count || 0) + 1)
    : Math.max(0, (existing?.play_count || 0) - 1);

  const { data } = await supabase
    .from('user_games')
    .upsert(
      { user_id: userId, game_id: gameId, play_count: newCount },
      { onConflict: 'user_id,game_id' }
    )
    .select('*')
    .single();
  return { ...data!, play_count: data!.play_count ?? 0 };
}

// Buscar jogos populares (por average_rating)
export async function getPopularGames(limit: number = 10): Promise<Game[]> {
  const { data, error } = await supabase
    .from('games')
    .select('*')
    .not('average_rating', 'is', null)
    .order('average_rating', { ascending: false, nullsFirst: false })
    .limit(limit);
  if (error) {
    console.error('getPopularGames error:', error);
    return [];
  }
  return (data || []).map((g: any) => ({
    ...g,
    stats: g.stats ?? undefined,
  }));
}
